import { hashKey, useQuery } from '@tanstack/react-query';
import z from 'zod';

import { TSDListItem } from '@e-origin/contracts';
import { SortDirection, TSDCriteria, TSDType } from '@e-origin/shared';

import { apiClient, STORAGE_KEYS } from '@utils';
import { getStoredCriteria } from '../../criteria.caching';
import { showErrorToast } from '../showErrorToast';

interface FetchTSDsResponse {
  list: TSDListItem[];
  total: number;
}

export const defaultTSDCriteria: TSDCriteria = {
  filters: { type: TSDType.COMBINED },
  pagination: { page: 1, size: 10, direction: 1, searchToken: '', currentToken: '' },
  sorting: { field: 'counter', direction: SortDirection.DESC },
};

export const getTSDInitialCriteria = () => {
  const storedCriteria = getStoredCriteria(STORAGE_KEYS.COOKIES.LIST_TSD_CRITERIA);

  return storedCriteria ?? defaultTSDCriteria;
};

export const useTSDs = (criteria: any) =>
  useQuery({
    queryKey: ['temporary-storages', hashKey(criteria)],
    queryFn: async (): Promise<FetchTSDsResponse> => {
      try {
        const result = await apiClient.tsd.retrieveTsds.mutation({ body: { criteria } });
        if (result.status !== 200) throw result.body;
        return {
          list: (result.body.data?.list as TSDListItem[]) ?? [],
          total: result.body.data?.totalItems ?? 0,
        };
      } catch (error) {
        showErrorToast(error, 'Failed to fetch temporary storages');
      }
    },
  });
